module.exports = __webpack_public_path__ + "img/67.8eb161af.jpg";